import React from 'react'
import * as UI from '@brewlogix/blx-ui'
import * as CC from '@chakra-ui/react'
import { Location } from 'src/types/schema/graphql'
import { mapStore } from 'src/features/Map/state/mapStore'
import CurrentDayStatus from 'src/features/locations/components/Details/CurrentDayStatus'
import { parseEnumLabel, parsePatronOptionToSlug } from 'src/util/helpers'
import tailwindConfig from '@brewlogix/blx-ui/tailwind.config'

interface ICardContent {
    location: Location
    index?: number
}

const CardContent: React.FC<ICardContent> = ({ location, index }) => {
    const dropdownToggleIndex = mapStore((state) => state.dropdownToggleIndex)
    const productsOnTap = location?.productRelationships.filter(
        (product) => product?.available && product?.onTap
    )?.length
    const getIconSlug = (iconName: string): string | null => {
        const iconSlug =
            iconName === 'WiFi_Available' ? 'HeroIcons.Wifi' : iconName.replace(/_/g, '')
        const icons: string[] = Object.keys(tailwindConfig.theme.icons)
        const iconExists = icons.includes(iconSlug)
        return iconExists ? iconSlug : null
    }
    return (
        <CC.Stack>
            {(location?.locationHighlights ||
                location?.traits?.patronOptions ||
                location?.hours) && (
                <div className={dropdownToggleIndex === index ? '' : 'mt-4 hidden lg:block'}>
                    {location?.hours && <CurrentDayStatus location={location} />}
                    {location?.locationHighlights?.length > 0 && (
                        <div className='mt-6 flex flex-wrap gap-2'>
                            {location?.locationHighlights?.map((option, i) => (
                                <UI.Pill
                                    icon={getIconSlug(option?.description)}
                                    iconAlignment='left'
                                    label={parseEnumLabel(option?.description)}
                                    key={option?.description + i}
                                    customClasses='whitespace-nowrap'
                                />
                            ))}
                        </div>
                    )}
                    {!location?.locationHighlights &&
                        location?.traits?.patronOptions?.length > 0 && (
                            <div className='mt-6 flex flex-wrap gap-2'>
                                {location?.traits?.patronOptions?.map((option) => (
                                    <UI.Pill
                                        icon={`${parsePatronOptionToSlug(option.toString())}`}
                                        iconAlignment='left'
                                        label={parseEnumLabel(option)}
                                        key={option}
                                        customClasses='whitespace-nowrap'
                                    />
                                ))}
                            </div>
                        )}
                    {productsOnTap > 0 && (
                        <UI.Pill
                            customClasses='whitespace-nowrap bg-yellow-50 mt-6'
                            theme='warning'
                        >
                            <span>On Tap</span>
                            <div className='flex  min-w-4 flex-col items-center justify-center rounded-full bg-dark px-1 text-yellow-50'>
                                {productsOnTap > 99 ? '99+' : productsOnTap}
                            </div>
                        </UI.Pill>
                    )}
                </div>
            )}
        </CC.Stack>
    )
}
export default CardContent
